/* THE PETRAIT — assets/petrait-premium-badge.js
   Injeta pequenos elementos na página de produto (etiqueta "Premium" nos swatches
   com padrão, ícones e preços nos botões da Tepo, barra de garantia, etc.).

   Versão otimizada (velocidade / INP):
   - O observador da página corre no máximo 1x por frame (requestAnimationFrame),
     em vez de correr tudo em cada pequena alteração do DOM.
   - Só reage a alterações dentro do formulário do produto, não da página inteira.
   - A lógica antiga dos acordeões (medir alturas + fechar os outros grupos) só corre
     nos produtos SEM multi-step; no multi-step o petrait-multistep.js já trata disso
     e os dois estavam a lutar entre si a cada clique.
*/
document.addEventListener('DOMContentLoaded', function () {
  var boltIcon = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23875361' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolygon points='13 2 3 14 12 14 11 22 21 10 12 10 13 2'/%3E%3C/svg%3E\")";
  var downloadIcon = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23875361' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'/%3E%3Cpolyline points='7 10 12 15 17 10'/%3E%3Cline x1='12' y1='15' x2='12' y2='3'/%3E%3C/svg%3E\")";

  function isMultistep() {
    return !!document.querySelector('.petrait-ms-step[data-step]');
  }

  function addExtrasIcons() {
    document.querySelectorAll('.tp-extras .tcustomizer-col').forEach(function (col, idx) {
      var btn = col.querySelector('.tcustomizer-btn');
      if (!btn || btn.querySelector('.petrait-extras-icon')) return;
      var icon = document.createElement('span');
      icon.className = 'petrait-extras-icon';
      icon.style.backgroundImage = idx === 0 ? boltIcon : downloadIcon;
      btn.insertBefore(icon, btn.firstChild);
    });
  }

  function ensureExtraBars() {
    if (document.querySelector('.petrait-guarantee-bar')) return;
    var buttons = document.querySelector('.product-form__buttons');
    if (!buttons || !buttons.parentNode) return;
    var guarantee = document.createElement('div');
    guarantee.className = 'petrait-guarantee-bar';
    guarantee.innerHTML = '<span class="petrait-guarantee-icon"></span><span>100% Artwork Satisfaction Guarantee</span>';
    buttons.parentNode.insertBefore(guarantee, buttons.nextSibling);
  }

  function addPetPrices() {
    var prices = ['', '+$35', '+$65', '+$95'];
    document.querySelectorAll('.tp-pet-count .tcustomizer-col').forEach(function (col, idx) {
      var btn = col.querySelector('.tcustomizer-btn');
      if (!btn || !prices[idx] || btn.querySelector('.petrait-pet-price')) return;
      var priceSpan = document.createElement('span');
      priceSpan.className = 'petrait-pet-price';
      priceSpan.textContent = prices[idx];
      btn.appendChild(priceSpan);
    });
  }

  function moveSaleBadge() {
    var badge = document.querySelector('.f-badge.f-badge--sale');
    var priceRow = document.querySelector('.f-price-sale');
    if (!badge || !priceRow || priceRow.contains(badge)) return;
    priceRow.appendChild(badge);
  }

  function addBadges() {
    document.querySelectorAll('.swatch-color[style*="background-image"]').forEach(function (swatch) {
      if (swatch.querySelector('.petrait-premium-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'petrait-premium-badge';
      badge.textContent = 'Premium';
      swatch.style.position = 'relative';
      swatch.appendChild(badge);
    });
  }

  function addSaveBadge() {
    var saleWrap = document.querySelector('.f-price.f-price--on-sale');
    if (!saleWrap || saleWrap.querySelector('.petrait-save-badge')) return;

    var saleEl = saleWrap.querySelector('.f-price-item--sale');
    var regularEl = saleWrap.querySelector('.f-price-item--regular');
    if (!saleEl || !regularEl) return;

    var saleMatch = saleEl.textContent.match(/[\d.,]+/);
    var regularMatch = regularEl.textContent.match(/[\d.,]+/);
    if (!saleMatch || !regularMatch) return;

    var diff = parseFloat(regularMatch[0].replace(',', '')) - parseFloat(saleMatch[0].replace(',', ''));
    if (diff <= 0) return;

    var badge = document.createElement('span');
    badge.className = 'petrait-save-badge';
    badge.textContent = 'Save $' + diff.toFixed(2).replace('.00', '');
    saleEl.insertAdjacentElement('afterend', badge);
  }

  // ---- Acordeões antigos (só produtos SEM multi-step) ----
  function syncAccordionHeights() {
    if (isMultistep()) return;
    document.querySelectorAll('[class*="petrait-group-"] .tcustomizer-accordion__content').forEach(function (content) {
      var want = content.classList.contains('opened') ? content.scrollHeight + 'px' : '0px';
      if (content.style.maxHeight !== want) content.style.setProperty('max-height', want, 'important');
    });
  }

  function runUpdate() {
    addBadges();
    addSaveBadge();
    moveSaleBadge();
    addExtrasIcons();
    addPetPrices();
    ensureExtraBars();
    syncAccordionHeights();
  }

  // No máximo uma atualização por frame
  var queued = false;
  function queueUpdate() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      runUpdate();
    });
  }

  runUpdate();

  // Só observa a zona do produto (onde a Tepo e as variantes mudam), não a página toda
  var scope = document.querySelector('.product__info-wrapper') ||
              document.querySelector('product-info') ||
              document.querySelector('#MainContent') ||
              document.body;
  new MutationObserver(queueUpdate).observe(scope, { childList: true, subtree: true });

  // A Tepo às vezes só termina de desenhar depois do primeiro ecrã
  setTimeout(queueUpdate, 1200);
  setTimeout(queueUpdate, 3500);

  document.addEventListener('click', function (e) {
    if (e.target.closest('fieldset[data-swatch-type="color_swatch"]') || e.target.closest('.tcustomizer-widget')) {
      setTimeout(queueUpdate, 60);
    }

    // Acordeão exclusivo (só sem multi-step): abrir um grupo fecha os outros.
    // Só reage a cliques reais, não aos que o script simula (evita loop).
    if (isMultistep()) return;
    var heading = e.target.closest('.tcustomizer-accordion__heading');
    if (!heading || !e.isTrusted) return;
    var clickedGroup = heading.closest('[class*="petrait-group-"]');
    if (!clickedGroup) return;
    setTimeout(function () {
      document.querySelectorAll('[class*="petrait-group-"]').forEach(function (group) {
        if (group === clickedGroup) return;
        var content = group.querySelector('.tcustomizer-accordion__content');
        if (content && content.classList.contains('opened')) {
          var otherHeading = group.querySelector('.tcustomizer-accordion__heading');
          if (otherHeading) otherHeading.click();
        }
      });
      syncAccordionHeights();
    }, 80);
  });

  // Os acordeões antigos mudam de classe (opened) sem alterar filhos
  var accordionObserver = new MutationObserver(function () { syncAccordionHeights(); });
  document.querySelectorAll('[class*="petrait-group-"] .tcustomizer-accordion__content').forEach(function (content) {
    accordionObserver.observe(content, { attributes: true, attributeFilter: ['class'] });
  });
});


/* THE PETRAIT — assets/petrait-redesign.js  (redesign Out 2026)
   1) Fundos em 2 linhas: título "Solid" por cima das cores lisas e
      "Premium patterns +$X" por cima dos padrões (preço extra lido do produto).
   2) Botão Next / Add to cart: texto + círculo rosa com seta (ou saco no último passo). */
(function () {
  // Swatches de fundo em 2 linhas (4 + 4): título "Solid" por cima das cores lisas
  // e "Premium patterns +$X" por cima dos padrões. O preço extra vem do próprio produto.
  var premiumExtra = null;
  function loadPremiumExtra() {
    if (premiumExtra !== null) return;
    premiumExtra = '';
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url).then(function (r) { return r.json(); }).then(function (p) {
      var fs = document.querySelector('fieldset.product-form__input--color[data-swatch-type="color_swatch"]');
      if (!fs || !p || !p.variants) return;
      var idx = -1;
      (p.options || []).forEach(function (o, i) {
        var name = (o && o.name ? o.name : o) + '';
        if (idx < 0 && /colou?r|background/i.test(name)) idx = i;
      });
      if (idx < 0) idx = 0;
      var premiumNames = {};
      fs.querySelectorAll('label').forEach(function (l) {
        if (l.querySelector('.swatch-color[style*="background-image"]')) {
          var inp = document.getElementById(l.getAttribute('for'));
          if (inp) premiumNames[inp.value] = true;
        }
      });
      var minSolid = Infinity, minPrem = Infinity;
      p.variants.forEach(function (v) {
        var val = v.options ? v.options[idx] : v['option' + (idx + 1)];
        if (premiumNames[val]) minPrem = Math.min(minPrem, v.price);
        else minSolid = Math.min(minSolid, v.price);
      });
      var diff = minPrem - minSolid;
      if (isFinite(diff) && diff > 0) {
        premiumExtra = ' +$' + (diff / 100).toFixed(2).replace(/\.00$/, '');
        document.querySelectorAll('.petrait-sw-head--premium i').forEach(function (h) {
          h.textContent = premiumExtra.trim();
        });
      }
    }).catch(function () {});
  }

  function addSwatchHeadings() {
    document.querySelectorAll('fieldset.product-form__input--color[data-swatch-type="color_swatch"]').forEach(function (fs) {
      var labels = Array.prototype.slice.call(fs.querySelectorAll(':scope > label'));
      if (!labels.length) return;
      var isPrem = function (l) { return !!l.querySelector('.swatch-color[style*="background-image"]'); };
      var firstSolid = null, firstPrem = null;
      labels.forEach(function (l) {
        if (isPrem(l)) { if (!firstPrem) firstPrem = l; }
        else if (!firstSolid) firstSolid = l;
      });
      if (!firstSolid || !firstPrem) return;
      fs.classList.add('petrait-sw-split');
      function place(label, cls, title, sub) {
        var anchor = label.previousElementSibling && label.previousElementSibling.tagName === 'INPUT' ? label.previousElementSibling : label;
        var prev = anchor.previousElementSibling;
        if (prev && prev.classList && prev.classList.contains(cls)) return;
        fs.querySelectorAll('.' + cls).forEach(function (h) { h.remove(); });
        var h = document.createElement('span');
        h.className = 'petrait-sw-head ' + cls;
        h.innerHTML = '<b></b><i></i>';
        h.firstChild.textContent = title;
        h.lastChild.textContent = sub;
        fs.insertBefore(h, anchor);
      }
      place(firstSolid, 'petrait-sw-head--solid', 'Solid', 'Included');
      place(firstPrem, 'petrait-sw-head--premium', 'Premium', (premiumExtra || '').trim());
      loadPremiumExtra();
    });
  }


  var ARROW_SVG = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
  var BAG_SVG = '<svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="9.5" cy="19.5" r="1.4"/><circle cx="17.5" cy="19.5" r="1.4"/><path d="M2.5 3.5h2.2l2.4 11.1a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.2L20.8 7.5H5.9"/></svg>';

  function styleNextBtn(btn) {
    if (btn.querySelector('.petrait-ms-next-text')) return;
    var isCart = /add to cart/i.test(btn.textContent || '');
    btn.innerHTML = '<span class="petrait-ms-next-text">' + (isCart ? 'Add to cart' : 'Next') + '</span>' +
      '<span class="petrait-ms-next-arrow">' + (isCart ? BAG_SVG : ARROW_SVG) + '</span>';
  }

  // Passos da barra de progresso clicáveis: avança (com as mesmas validações do Next)
  // ou recua até ao passo escolhido
  function currentIndex(steps) {
    for (var i = 0; i < steps.length; i++) if (steps[i].classList.contains('is-current')) return i;
    return 0;
  }
  function goToStep(li) {
    var steps = Array.prototype.slice.call(document.querySelectorAll('.petrait-progress__step'));
    var target = steps.indexOf(li);
    var next = document.getElementById('petraitNextBtn');
    var back = document.getElementById('petraitBackBtn');
    if (target < 0 || !next || !back) return;
    var guard = 0;
    while (guard++ < 10) {
      steps = Array.prototype.slice.call(document.querySelectorAll('.petrait-progress__step'));
      var cur = currentIndex(steps);
      if (cur === target) break;
      if (target > cur) {
        if (cur >= steps.length - 1) break;
        next.click();
      } else {
        back.click();
      }
      if (currentIndex(Array.prototype.slice.call(document.querySelectorAll('.petrait-progress__step'))) === cur) break;
    }
  }
  function markStepsClickable() {
    document.querySelectorAll('.petrait-progress__step:not([tabindex])').forEach(function (li) {
      li.setAttribute('tabindex', '0');
      li.setAttribute('role', 'button');
    });
  }
  document.addEventListener('click', function (e) {
    var li = e.target.closest && e.target.closest('.petrait-progress__step');
    if (li) goToStep(li);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var li = e.target.closest && e.target.closest('.petrait-progress__step');
    if (!li) return;
    e.preventDefault();
    goToStep(li);
  });

  // Etiqueta por cima do Next: "Subtotal $X ~~$Y~~ · Free Shipping Over $100".
  // O subtotal é o preço principal do produto, que o tema já atualiza com os add-ons.
  function priceInfo() {
    var btn = document.getElementById('petraitNextBtn');
    var sc = (btn && (btn.closest('product-info') || btn.closest('.product__info-wrapper'))) || document;
    var p = sc.querySelector('.f-price--large') || sc.querySelector('.f-price');
    if (!p) return null;
    var sale = p.querySelector('.f-price-item--sale');
    var clean = function (t) { return (t || '').replace(/from/i, '').replace(/\s+/g, ' ').trim(); };
    var regs = Array.prototype.map.call(p.querySelectorAll('.f-price-item--regular'), function (e) { return clean(e.textContent); })
      .filter(function (t) { return !!t; });
    var now = clean(sale ? sale.textContent : '') || regs[0] || '';
    var was = p.classList.contains('f-price--on-sale') ? (regs[regs.length - 1] || '') : '';
    if (was === now) was = '';
    return { now: now, was: was };
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function renderShipRow() {
    var row = document.querySelector('.petrait-ms-ship-row');
    if (!row) return;
    var info = priceInfo();
    var digital = document.documentElement.classList.contains('petrait-digital');
    var right = digital ? 'Digital file, delivered by email' : 'Free shipping over $100';
    var key = (info ? info.now + '|' + info.was : '') + '|' + (digital ? 'd' : 's');
    if (row.getAttribute('data-pt-key') === key && row.querySelector('.pt-ship')) return;
    var left = info && info.now
      ? '<span class="pt-sub">Subtotal <b>' + esc(info.now) + '</b>' + (info.was ? ' <s>' + esc(info.was) + '</s>' : '') + '</span><span class="pt-sep" aria-hidden="true">·</span>'
      : '';
    row.setAttribute('data-pt-key', key);
    row.innerHTML = left + '<span class="pt-ship">' + right + '</span>';
  }

  // Review: a linha do fundo mostra a cor/padrão escolhido num círculo
  function reviewSwatch() {
    var val = document.getElementById('reviewBg');
    var row = val && val.parentElement;
    if (!row) return;
    var input = document.querySelector('fieldset.product-form__input--color input[type="radio"]:checked');
    var label = input && document.querySelector('label[for="' + input.id + '"]');
    var sw = label && label.querySelector('.swatch-color');
    if (!sw) return;
    var cs = getComputedStyle(sw);
    var bg = (cs.backgroundImage && cs.backgroundImage !== 'none' ? cs.backgroundImage + ' center / cover no-repeat, ' : '') + cs.backgroundColor;
    if (row.getAttribute('data-pt-sw') === bg) return;
    row.setAttribute('data-pt-sw', bg);
    row.style.setProperty('--pt-sw', bg);
  }

  // Campos em falta: ficam a vermelho e abanam (em vez de só aparecer uma caixa de aviso)
  function shake(el) {
    el.classList.remove('pt-shake');
    void el.offsetWidth;
    el.classList.add('pt-shake');
  }
  function markInvalid() {
    var err = document.getElementById('petraitError');
    if (!err || !err.classList.contains('visible')) return;
    var t = (err.textContent || '').toLowerCase();
    var els = [];
    if (/layout/.test(t)) {
      var row = document.querySelector('.petrait-group-layout .tcustomizer-row');
      if (row) els.push(row);
    } else if (/phone model/.test(t)) {
      var dd = document.querySelector('.petrait-group-1 .tp-model-dropdown .tcustomizer__dropdown-button') ||
               document.querySelector('.petrait-group-1 .tcustomizer__dropdown-button');
      if (dd) els.push(dd);
    } else if (/photo|pet name/.test(t)) {
      document.querySelectorAll('.petrait-group-2 .tcustomizer-field--FileUpload').forEach(function (f) {
        if (!f.querySelector('.tcustomizer-file-item')) els.push(f);
      });
      document.querySelectorAll('.petrait-group-2 .tp-pet-name input').forEach(function (i) {
        if (!i.value.trim()) els.push(i.closest('.tcustomizer__text-field-wrapper') || i);
      });
    }
    els.forEach(function (el) { el.classList.add('pt-invalid'); shake(el); });
    shake(err);
  }
  function clearValid() {
    var err = document.getElementById('petraitError');
    var errOn = !!(err && err.classList.contains('visible'));
    document.querySelectorAll('.pt-invalid').forEach(function (el) {
      var ok = !errOn;
      if (!ok) {
        if (el.classList.contains('tcustomizer-field--FileUpload')) ok = !!el.querySelector('.tcustomizer-file-item');
        else if (el.classList.contains('tcustomizer-row')) ok = !!el.querySelector('.tcustomizer-btn--active, input:checked');
        else if (el.classList.contains('tcustomizer__dropdown-button')) {
          var s = (el.textContent || '').trim().toLowerCase();
          ok = !!s && s !== 'select an option';
        } else {
          var inp = el.tagName === 'INPUT' ? el : el.querySelector('input');
          ok = !!(inp && inp.value.trim());
        }
      }
      if (ok) el.classList.remove('pt-invalid');
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#petraitNextBtn, .petrait-progress__step')) setTimeout(markInvalid, 0);
  });
  document.addEventListener('input', clearValid);
  document.addEventListener('change', clearValid);

  // Opções com muitos valores (ex.: modelo do MacBook): lista pendente em vez de botões
  function buttonsToSelect() {
    document.querySelectorAll('variant-selects fieldset.product-form__input--button').forEach(function (fs) {
      var radios = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
      var isModel = !!fs.querySelector('[data-selected-swatch-value="Model"]');
      if (!isModel && radios.length <= 6) return;
      fs.classList.add('pt-as-select');
      var sel = fs.querySelector('select.pt-opt-select');
      if (!sel) {
        var wrap = document.createElement('div');
        wrap.className = 'pt-opt-select-wrap';
        sel = document.createElement('select');
        sel.className = 'pt-opt-select';
        var lg = fs.querySelector('legend');
        sel.setAttribute('aria-label', isModel ? 'Model' : (lg ? lg.textContent.split(':')[0].trim() : 'Option'));
        wrap.appendChild(sel);
        fs.appendChild(wrap);
        sel.addEventListener('change', function () {
          var r = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')).filter(function (x) { return x.value === sel.value; })[0];
          if (r && !r.checked) r.click();
        });
      }
      var key = radios.map(function (r) { return r.value + (r.disabled ? '*' : ''); }).join('|');
      if (sel.getAttribute('data-key') !== key) {
        sel.innerHTML = '';
        radios.forEach(function (r) {
          var o = document.createElement('option');
          o.value = r.value;
          o.textContent = r.value + (r.disabled ? ' (sold out)' : '');
          o.disabled = r.disabled;
          sel.appendChild(o);
        });
        sel.setAttribute('data-key', key);
      }
      var c = radios.filter(function (r) { return r.checked; })[0];
      if (c && sel.value !== c.value) sel.value = c.value;
    });
  }

  function init() {
    buttonsToSelect();
    renderShipRow();
    reviewSwatch();
    var btn = document.getElementById('petraitNextBtn');
    if (btn) {
      styleNextBtn(btn);
      new MutationObserver(function () { styleNextBtn(btn); }).observe(btn, { childList: true });
    }
    addSwatchHeadings();
    markStepsClickable();
    var queued = false;
    var scope = document.querySelector('.product__info-wrapper') || document.querySelector('product-info') || document.body;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; buttonsToSelect(); addSwatchHeadings(); markStepsClickable(); renderShipRow(); reviewSwatch(); clearValid(); });
    }).observe(scope, { childList: true, subtree: true, characterData: true });
    setTimeout(renderShipRow, 1500);
    setTimeout(renderShipRow, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
